"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.createExposedErrorHandler = exports.ExposedError = void 0;
var ExposedError = /** @class */ (function (_super) {
    __extends(ExposedError, _super);
    function ExposedError(message, code) {
        var _this = _super.call(this, message) || this;
        _this.name = 'ExposedError';
        _this.message = message;
        _this.code = code;
        Error.captureStackTrace(_this, ExposedError);
        return _this;
    }
    return ExposedError;
}(Error));
exports.ExposedError = ExposedError;
function createExposedErrorHandler(logger, AuthenticationError) {
    return function (error, unexpectedErrorMessage) {
        // Log full error with context to Sentry
        logger.error(error);
        if (AuthenticationError && error instanceof AuthenticationError) {
            // Right now we can't alter the AuthenticationError because the Access App depends on its
            // code being "UNAUTHENTICATED" to handle reactive session renewal
            throw error;
        }
        else {
            // We cannot use "instanceof" here because the package and the service
            // each get their own copy of the constructor
            var isExposedError = error.name === 'ExposedError';
            // Get exposed error message for client
            var exposedErrorMessage = (isExposedError && error.message)
                ? error.message
                : unexpectedErrorMessage;
            // Only use the unexpected error code if it's not an exposed error
            var code = isExposedError ? error.code : 'UNEXPECTED';
            // Rethrow new exposed error for the client without any attached context
            // (i.e., only the message and code, if applicable)
            throw new ExposedError(exposedErrorMessage, code);
        }
    };
}
exports.createExposedErrorHandler = createExposedErrorHandler;
//# sourceMappingURL=ExposedError.js.map